import axios from 'axios';
import { getToken } from './auth';

export const checkTokenValidity = async () => {
  const token = getToken();

  if (!token) return false;

  try {
    const response = await axios.get(`${process.env.REACT_APP_URL}/api/user`, {
      headers: {
        'Authorization': `Bearer ${token}`,
      },
    });

    if (response.status === 200) {
      return true;
    } else {
      return false;
    }
  } catch (error) {
    console.error('Error checking token validity:', error);
    return false;
  }
};
